<template>
  <div class="chartType-list">
    <div class="pie">
      <div
        class="figure"
        :class="{
          isChartTypeActive: chartType === 'PieChart',
          disabled: SpriteOperation === 'swap',
        }"
        alt
        @click="switchChartType('PieChart')"
      >
        <span class="companyVip" v-if="!UserEquity.Echart && showMark"></span>
        <!-- <div class="mask"></div> -->
      </div>
      <span>饼图</span>
    </div>
    <div class="line">
      <div
        class="figure"
        :class="{
          isChartTypeActive: chartType === 'LineChart',
          disabled: SpriteOperation === 'swap',
        }"
        alt
        @click="switchChartType('LineChart')"
      >
        <span class="companyVip" v-if="!UserEquity.Echart && showMark"></span>
        <!-- <div class="mask"></div> -->
      </div>
      <span>折线图</span>
    </div>
    <div class="bar">
      <div
        class="figure"
        :class="{
          isChartTypeActive: chartType === 'BarChart',
          disabled: SpriteOperation === 'swap',
        }"
        alt
        @click="switchChartType('BarChart')"
      >
        <span class="companyVip" v-if="!UserEquity.Echart && showMark"></span>
        <!-- <div class="mask"></div> -->
      </div>
      <span>柱状图</span>
    </div>
  </div>
</template>

<script>
import AnalysisBu from "../../mixins/analysis/materialBu";
import { mapGetters } from "vuex";
import analysis from "@/components/mixins/analysis/spriteBtns";

export default {
  mixins: [AnalysisBu, analysis],
  data() {
    return {
      id: "",
      scenesId: "",
      chartType: "",
      originalChartType: "",
      option: {},
      barStyle: {
        axisStyle: {
          valueMarkerFormat: {
            fontFamily: "Microsoft YaHei",
            fontSize: 14.0,
            foreground: "#424f61",
            isBold: false,
            thickness: {
              left: 0.0,
              top: 0.0,
              right: 14.0,
              bottom: 0.0,
            },
          },
          valueMarkerLineLength: 2.0,
          lineWidth: 2.0,
          lineColor: "#424f61",
          dataAreaHeight: 288.0,
          topSpace: 22.0,
          rightSpace: 22.0,
          startOffset: 22.0,
          arrowWidth: 10.0,
          arrowHeight: 8.0,
        },
        groupLabelFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 14.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 12.0,
            right: 0.0,
            bottom: 0.0,
          },
        },
        barBorderWidth: 2.0,
        barBorderColor: "#424f61",
        barMaxWidth: 86.0,
        barMinWidth: 20.0,
        barMaxNumber: 4,
        groupSpace: 30.0,
        barSpace: 2.0,
        chartType: 0,
        titleFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 18.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 0.0,
            right: 0.0,
            bottom: 30.0,
          },
        },
        dataLabelFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 10.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 4.0,
            right: 0.0,
            bottom: 0.0,
          },
        },
        legendStyle: {
          colorBlockWidth: 8.0,
          colorBlockHeight: 8.0,
          labelFormat: {
            fontFamily: "Microsoft YaHei",
            fontSize: 14.0,
            foreground: "#424f61",
            isBold: false,
            thickness: {
              left: 4.0,
              top: 0.0,
              right: 20.0,
              bottom: 20.0,
            },
          },
          thickness: {
            left: 14.0,
            top: 46.0,
            right: 0.0,
            bottom: 0.0,
          },
        },
        colorSpace: [
          "#f9f9f9",
          "#bebebe",
          "#f6cb78",
          "#9cd5ff",
          "#dddddd",
          "#6a6a6a",
        ],
      },
      lineStyle: {
        axisStyle: {
          valueMarkerFormat: {
            fontFamily: "Microsoft YaHei",
            fontSize: 14.0,
            foreground: "#424f61",
            isBold: false,
            thickness: {
              left: 0.0,
              top: 0.0,
              right: 14.0,
              bottom: 0.0,
            },
          },
          valueMarkerLineLength: 2.0,
          lineWidth: 2.0,
          lineColor: "#424f61",
          dataAreaHeight: 288.0,
          topSpace: 22.0,
          rightSpace: 22.0,
          startOffset: 22.0,
          arrowWidth: 10.0,
          arrowHeight: 8.0,
        },
        groupLabelFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 14.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 12.0,
            right: 0.0,
            bottom: 0.0,
          },
        },
        dataAreaWidth: 580.0,
        lineWidth: 2.0,
        dotSizeWidth: 8.0,
        dotSizeHeight: 8.0,
        dotShape: 0,
        chartType: 2,
        titleFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 18.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 0.0,
            right: 0.0,
            bottom: 30.0,
          },
        },
        dataLabelFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 10.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 4.0,
            right: 0.0,
            bottom: 0.0,
          },
        },
        legendStyle: {
          colorBlockWidth: 8.0,
          colorBlockHeight: 8.0,
          labelFormat: {
            fontFamily: "Microsoft YaHei",
            fontSize: 14.0,
            foreground: "#424f61",
            isBold: false,
            thickness: {
              left: 4.0,
              top: 0.0,
              right: 20.0,
              bottom: 20.0,
            },
          },
          thickness: {
            left: 14.0,
            top: 46.0,
            right: 0.0,
            bottom: 0.0,
          },
        },
        colorSpace: [
          "#d0d0d0",
          "#ffc773",
          "#abde64",
          "#c9f4f3",
          "#64b3d5",
          "#e86a57",
        ],
      },
      pieStyle: {
        radius: 144.0,
        borderWidth: 2.0,
        borderColor: "#ffffff",
        chartType: 1,
        titleFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 18.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 0.0,
            right: 0.0,
            bottom: 30.0,
          },
        },
        dataLabelFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 10.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 48.0,
            right: 0.0,
            bottom: 0.0,
          },
        },
        legendStyle: {
          colorBlockWidth: 8.0,
          colorBlockHeight: 8.0,
          labelFormat: {
            fontFamily: "Microsoft YaHei",
            fontSize: 14.0,
            foreground: "#424f61",
            isBold: false,
            thickness: {
              left: 4.0,
              top: 0.0,
              right: 20.0,
              bottom: 20.0,
            },
          },
          thickness: {
            left: 20.0,
            top: 22.0,
            right: 0.0,
            bottom: 0.0,
          },
        },
        colorSpace: [
          "#d0d0d0",
          "#ffc773",
          "#abde64",
          "#c9f4f3",
          "#64b3d5",
          "#e86a57",
        ],
      },
      data: {
        title: "",
        groupLabels: ["类别1", "类别2", "类别3", "类别4", "类别5", "类别6"],
        legendItemLabels: ["系列1", "系列2", "系列3", "系列4"],
        data: [
          [, , , , , ,],
          [, , , , , ,],
          [, , , , , ,],
          [, , , , , ,],
        ],
        legendPosition: 0,
        isShowTitle: true,
        isShowGroupLabels: true,
        isShowLegend: true,
        isShowDataValues: true,
      },
    };
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "MaterialPane_Size",
      "SetPanel_Size",
      "TOOL",
      "SelectSprites_Msg",
      "StyleDataMsg",
      "SpriteOperation",
      "SpriteBeforeSwap",
      "UserEquity",
    ]),
  },
  props: ["chartFrom", "dataMsg", "boxDatas", "showMark"],
  mounted() {
    if (this.chartFrom !== "rightNav") {
      // 获取已有图表数据
      this.id = this.TOOL.selectedSprite[0].id;
      this.scenesId = this.TOOL.selectedSprite[0].scenesId;
      this.option = JSON.parse(
        JSON.stringify(this.TOOL.selectedSprite[0].option)
      );
      this.chartType = this.originalChartType = this.option.chartType;
    }
  },
  methods: {
    switchChartType(type) {
      // if (this.SpriteOperation === 'swap') {
      //   return;
      // }
      // report
      this.reportByCase(type, this.chartFrom);
      switch (type) {
        case "BarChart":
          switch (this.chartFrom) {
            case "rightNav":
              this.materialPushAnalysis({ type: "shapeBar" });
              break;
          }
          break;
        case "LineChart":
          switch (this.chartFrom) {
            case "rightNav":
              this.materialPushAnalysis({ type: "shapeLine" });
              break;
          }
          break;
        case "PieChart":
          switch (this.chartFrom) {
            case "rightNav":
              this.materialPushAnalysis({ type: "shapePie" });
              break;
          }
          break;
      }

      this.$bus.emit("changeChartType", type);
      // 选择风格样式，如果图表已经存在，则使用初始样式风格，否则使用当前风格
      if (this.chartFrom === "rightNav") {
        //弹出气泡提示
        this.$bus.emit("showTips", {
          text:
            "在表格中可以输入数据并生成图表，更新数据后记得点击“确认”才会生效哦！",
          position: {
            top: "380px",
            left: `${this.MaterialPane_Size.width + 100}px`,
          },
        });
        // 从右侧栏插入图表
        switch (type) {
          case "BarChart":
            this.data.data = [
              [15, 20, 36, , , ,],
              [20, 25, 56, , , ,],
              [, , , , , ,],
              [, , , , , ,],
            ];
            this.option.data = Object.assign({}, this.data);
            break;
          case "LineChart":
            this.data.data = [
              [15, 20, 36, , , ,],
              [20, 25, 56, , , ,],
              [, , , , , ,],
              [, , , , , ,],
            ];
            this.option.data = Object.assign({}, this.data);
            break;
          case "PieChart":
            this.data.data = [
              [10, 20, 30, 40, , ,],
              [, , , , , ,],
              [, , , , , ,],
              [, , , , , ,],
            ];
            this.option.data = Object.assign({}, this.data);
            break;
        }
        this.option.styleId = this.StyleDataMsg.id;
        this.option.data = Object.assign({}, this.data);
      } else {
        this.option = Object.assign({}, this.TOOL.selectedSprite[0].option);
        this.data = Object.assign({}, this.TOOL.selectedSprite[0].option.data);
      }
      this.chartType = type;
      this.option.chartType = type;
      switch (this.option.styleId) {
        case 78: // 商务科技
        case 92: // 真实场景
          this.barStyle.barBorderWidth = 0;
          this.barStyle.barBorderColor = "#ffffff";
          this.pieStyle.borderColor = "#ffffff";
          this.barStyle.dataLabelFormat.foreground = this.lineStyle.dataLabelFormat.foreground = this.pieStyle.dataLabelFormat.foreground =
            "#424f61";
          this.barStyle.colorSpace = this.lineStyle.colorSpace = this.pieStyle.colorSpace = [
            "#dee1e3",
            "#33ab9a",
            "#3ed2e7",
            "#b0b4ba",
            "#48d7ca",
            "#2399c4",
          ];
          break;
        case 80: // 扁平简约
        case 91: // 数据图表
          this.barStyle.barBorderWidth = 0;
          this.barStyle.barBorderColor = "#ffffff";
          this.pieStyle.borderColor = "#ffffff";
          this.barStyle.dataLabelFormat.foreground = this.lineStyle.dataLabelFormat.foreground = this.pieStyle.dataLabelFormat.foreground =
            "#424f61";
          this.barStyle.colorSpace = this.lineStyle.colorSpace = this.pieStyle.colorSpace = [
            "#d0d0d0",
            "#ffc773",
            "#abde64",
            "#c9f4f3",
            "#64b3d5",
            "#e86a57",
          ];
          break;
        case 79: // 卡通动漫
          this.barStyle.barBorderWidth = 0;
          this.barStyle.barBorderColor = "#ffffff";
          this.pieStyle.borderColor = "#ffffff";
          this.barStyle.dataLabelFormat.foreground = this.lineStyle.dataLabelFormat.foreground = this.pieStyle.dataLabelFormat.foreground =
            "#ffffff";
          this.barStyle.colorSpace = this.lineStyle.colorSpace = this.pieStyle.colorSpace = [
            "#ffc132",
            "#ffa2a0",
            "#31dff8",
            "#5758fb",
            "#ba57fc",
            "#98e560",
          ];
          break;
        case 81: // 黑白手绘
          this.barStyle.barBorderWidth = 2.0;
          this.barStyle.barBorderColor = "#424f61";
          this.pieStyle.borderColor = "#424f61";
          this.barStyle.dataLabelFormat.foreground = this.lineStyle.dataLabelFormat.foreground = this.pieStyle.dataLabelFormat.foreground =
            "#424f61";
          this.barStyle.colorSpace = this.lineStyle.colorSpace = this.pieStyle.colorSpace = [
            "#f9f9f9",
            "#bebebe",
            "#f6cb78",
            "#9cd5ff",
            "#dddddd",
            "#6a6a6a",
          ];
          break;
        default:
          console.log("无此风格的图表！");
          break;
      }
      switch (type) {
        case "BarChart":
          this.option.style = Object.assign({}, this.barStyle);
          break;
        case "LineChart":
          this.option.style = Object.assign({}, this.lineStyle);
          break;
        case "PieChart":
          this.option.style = Object.assign({}, this.pieStyle);
          break;
      }
      this.option.chartOption = Object.assign(
        {},
        this.$chartFromJson(this.option)
      );
      if (this.chartFrom === "rightNav") {
        // 从右侧插入新表
        const added = () => {
          setTimeout(() => {
            this.$bus.emit("FeaturesPop_vue", {
              name: "edit_Chart",
              // 使表格弹窗在画布居中显示，867和282分别为表格的宽高。
              posx:
                this.MaterialPane_Size.width +
                this.TOOL.fixLeft +
                (this.TOOL.clientWidth - 867) / 2,
              posy:
                this.TopNav_Size.height +
                this.TOOL.fixTop +
                (this.TOOL.clientHeight - 282) / 2,
              type: 1,
              sprite: this.TOOL.selectedSprite[0],
            });
          });
        };
        const added2 = () => {
          setTimeout(() => {
            this.chartType = this.originalChartType = "";
          }, 500);
        };
        this.SpriteOperation === "add" &&
          this.TOOL.addSprite("Chart", this.option, null, true)
            .then(added)
            .then(added2);

        // 切换成图表
        this.SpriteOperation === "swap" &&
          this.TOOL.swapSprite({
            sprite: this.SpriteBeforeSwap,
            typeForAdd: "Chart",
            optionForAdd: this.option,
          })
            .then(added)
            .then(added2);
      } else {
        // 撤销相关代码
        let data = {
          undo: {},
          redo: {},
        };

        // 已有图表切换图表类型
        this.TOOL.updateSprite(this.id, this.option, this.scenesId, true);
        setTimeout(() => {
          this.option = Object.assign({}, this.TOOL.selectedSprite[0].option);
          this.chartType = this.originalChartType = this.option.chartType;
        });
        if (this.dataMsg && this.dataMsg.switch_Chart) {
          // 关闭单独切换图表类型弹窗，不关闭图表设置弹窗
          this.$bus.emit("FeaturesPop_close_vue", {
            name: "switch_Chart",
            type: 1,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chartType-list {
  width: 100%;
  height: 110px;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
  .figure {
    display: block;
    width: 64px;
    height: 54px;
    background-color: #f0f0f8;
    margin-top: 13px;
    margin-bottom: 13px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      border-color: #5778fb;
    }
  }
  .isChartTypeActive {
    border: 2px solid #5778fb;
  }
  // .label {
  //   position: absolute;
  //   bottom: 5px;
  //   right: 5px;
  //   line-height: 14px;
  //   height: 14px;
  //   background-image: linear-gradient(108deg, #36332f 0%, #12100a 100%);
  //   border-radius: 7px;
  //   border: solid 1px #ffffff;
  //   color: #f9d8a4;
  //   box-shadow: 0px 0px 4px 0px rgba(148, 74, 14, 0.49);
  //   padding: 0 7px;
  //   font-family: MicrosoftYaHei-Bold;
  //   font-size: 12px;
  //   font-weight: 700;
  //   font-stretch: normal;
  //   letter-spacing: 0px;
  // }
  .companyVip {
    position: absolute;
    bottom: 4px;
    right: 4px;
    width: 50px;
    height: 14px;
    background-image: url(../../../../static/svg/payTypeSubscript/companyVip50x14.svg);
    background-size: cover;
    background-repeat: no-repeat;
  }
  .pie {
    .figure {
      position: relative;
      background-image: url("../../../../static/svg/pie.svg");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 22px 22px;
      border: 2px solid #fff;
      overflow: hidden;
    }
  }
  .line {
    .figure {
      position: relative;
      background-image: url("../../../../static/svg/line.svg");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 23px 20px;
      border: 2px solid #fff;
      overflow: hidden;
    }
  }
  .bar {
    .figure {
      position: relative;
      background-image: url("../../../../static/svg/bar.svg");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 26px 26px;
      border: 2px solid #fff;
      overflow: hidden;
    }
  }
  .figure {
    position: relative;
    & > .mask {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(#000, 0.5);
    }
    &.disabled {
      & > .mask {
        display: block;
        cursor: not-allowed;
      }
      &:hover {
        border-color: transparent;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/popups/content/switchChartType.vue